import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Wordmark } from "../components/BrandLogo";
import { api } from "../lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", {
        email,
        origin_url: window.location.origin,
      });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ss-soft-bg min-h-[100dvh] w-full">
      <div className="mx-auto w-full max-w-md min-h-[100dvh] px-8 py-10 flex flex-col">
        <Wordmark className="mb-10" />
        {!sent ? (
          <>
            <h1 className="font-serif text-3xl">{t("forgot.h")}</h1>
            <p className="text-foreground/65 text-sm mt-2 leading-relaxed">{t("forgot.sub")}</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <Label className="text-xs uppercase tracking-wider text-foreground/60">{t("auth.email")}</Label>
                <Input
                  data-testid="forgot-email-input"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 h-13 rounded-2xl bg-card border-border px-5"
                />
              </div>
              <Button
                data-testid="forgot-submit-btn"
                id="forgot-submit"
                disabled={busy}
                className="w-full h-14 rounded-full bg-brand hover:bg-brand/90 text-white text-base"
              >
                {busy ? t("forgot.sending") : t("forgot.send")}
              </Button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-sent" className="animate-fade-up">
            <p className="font-script text-2xl text-brand">{t("forgot.sent_kicker")}</p>
            <h1 className="font-serif text-3xl mt-1 leading-tight">{t("forgot.sent_h")}</h1>
            <p className="mt-3 text-foreground/70 leading-relaxed">
              <Trans
                i18nKey="forgot.sent_sub"
                values={{ email }}
                components={{ strong: <strong /> }}
              />
            </p>
            <p className="mt-3 text-foreground/55 text-sm leading-relaxed">{t("forgot.sent_spam")}</p>
            <Button
              data-testid="forgot-back-btn"
              onClick={() => navigate("/auth")}
              className="mt-8 w-full h-13 rounded-full bg-brand hover:bg-brand/90 text-white"
            >
              {t("forgot.back_signin")}
            </Button>
          </div>
        )}

        <div className="mt-auto pt-10">
          <Link
            to="/auth"
            data-testid="forgot-cancel-link"
            className="text-sm text-foreground/50 hover:text-brand"
          >
            ← {t("forgot.back_signin")}
          </Link>
        </div>
      </div>
    </div>
  );
}
